import { gql } from '../__generated__';
import { DiscountItem, DiscountOverviewItem } from '../interfaces.graphql';

export const GET_DISCOUNTS = gql(`
  query GetDiscounts($id: Int!) {
    discounts: getDiscounts(id: $id) {
      ...DiscountOverviewItem
    }
  }
`);

export const GET_DISCOUNT = gql(`
  query GetDiscount($id: ID!) {
    discount: getDiscount(id: $id) {
      ...DiscountItem
    }
  }
`);

export const GET_DISCOUNT_TOKEN = gql(`
  query GetDiscountToken($id: ID!) {
    discountToken: getDiscountToken(id: $id) {
      id
    }
  }
`);

export const GET_USAGES = gql(`
  query GetUsages($id: ID!) {
    licenses: getDiscountUsages(id: $id) {
      id
      companyName
      orgNumber
      customerNumber
      administrator
      adminEmail      
      isDeleted
      createdAt
    }
  }
`);

export const CREATE_DISCOUNT = gql(`
  mutation CreateDiscount($input: CreateDiscountInput!) {
    createDiscount(input: $input) {
      ...DiscountItem
    }
  }
`);

export const DELETE_DISCOUNT = gql(`
  mutation DeleteDiscount($input: DeleteDiscountInput!) {
    deleteDiscount(input: $input)
  }
`);

export const DEACTIVATE_DISCOUNT = gql(`
  mutation DeactivateDiscount($input: DeactivateDiscountInput!) {
    deactivateDiscount(input: $input) {
      ...DiscountItem
    }
  }
`);

export const UPDATE_DISCOUNT = gql(`
  mutation UpdateDiscount($input: UpdateDiscountInput!) {
    updateDiscount(input: $input) {
      ...DiscountItem
    }
  }
`);

export const UPDATE_VALUE = gql(`
  mutation UpdateDiscountValue($input: UpdateDiscountValueInput!) {
    updateDiscountValue(input: $input) {
      ...DiscountItem
    }
  }
`);

export const UPDATE_EMAIL_FILTER = gql(`
  mutation UpdateDiscountEmailFilter($input: UpdateDiscountEmailFilterInput!) {
    updateDiscountEmailFilter(input: $input) {
      ...DiscountItem
    }
  }
`);

export const CANCEL_VALUE_UPDATE = gql(`
  mutation cancelDiscountValueUpdate($input: CancelDiscountValueUpdateInput!) {
    cancelDiscountValueUpdate(input: $input) {
      ...DiscountItem
    }
  }
`);

export const GET_SUBSCRIPTIONS = gql(`
  query GetDiscountSubscriptions {
    subscriptions: allSubscriptions(onlyPaid: true) {
      id
      name
      number
      parentId
    }
  }
`);

export const GET_DISCOUNT_COHORT_ANALYSIS = gql(`
  query GetDiscountCohortAnalysis($discountName: String!, $yearsBack: Int!, $startYear: Int, $endYear: Int) {
    getDiscountCohortAnalysis(discountName: $discountName, yearsBack: $yearsBack, startYear: $startYear, endYear: $endYear) {
      discountName
      discountId
      cohortData {
        cohortYear
        initialCustomers
        yearlyActivity {
          year
          activeCustomers
        }
      }
      yearlyTotals {
        year
        totalActiveCustomers
      }
      retentionRates {
        fromYear
        toYear
        retentionRate
      }
      analysisStartYear
      analysisEndYear
      totalCustomersAnalyzed
      analysisDate
      errorMessage
    }
  }
`);
